export enum LivestockWeightType {
  Visual = "VISUAL",
  Measured = "PESADO",
  Projected = "PROJETADO",
  Goal = "OBJETIVO",
  Exit = "SAIDA",
}
